import React, { useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { useCurrentPlayer } from '../hooks/useCurrentPlayer';
import 'font-awesome/css/font-awesome.min.css';
import './Navbar.css';

function Navbar({ isAuthenticated, isAdmin, isCaptain }) {
    const navigate = useNavigate();
    const { signOut, user } = useAuth();
    const { player } = useCurrentPlayer();

    const [isOpen, setIsOpen] = useState(false);

    const displayNameRaw = player?.name || user?.email || 'Usuario';
    const displayName = displayNameRaw.charAt(0).toUpperCase() + displayNameRaw.slice(1);

    const toggleMenu = () => setIsOpen(!isOpen);
    const closeMenu  = () => setIsOpen(false);

    const handleLogout = async () => {
        closeMenu();
        await signOut();
        navigate('/login');
    };

    const handleNavigation = (path) => {
        navigate(path);
        closeMenu();
    };

    const navLinkClass = ({ isActive }) =>
        `nav-link${isActive ? ' nav-link--active' : ''}`;

    return (
        <>
            <nav className="custom-navbar">
                {/* Logo */}
                <Link to="/" className="navbar-brand" aria-label="Ir a inicio">
                    <img src="/pics/logopanteres.png" alt="Panteres Grogues" className="navbar-logo" />
                </Link>

                {isAuthenticated && (
                    <>
                        {/* Links centrales — solo desktop */}
                        <div className="navbar-center">
                            <NavLink to="/dashboard" className={navLinkClass}>
                                <i className="fa fa-home"></i>
                                <span>Liga</span>
                            </NavLink>
                            {isCaptain && (
                                <NavLink to="/estadisticas" className={navLinkClass}>
                                    <i className="fa fa-bar-chart"></i>
                                    <span>Estadísticas</span>
                                </NavLink>
                            )}
                            <NavLink to="/americanas" className={navLinkClass}>
                                <i className="fa fa-star"></i>
                                <span>Americanas</span>
                            </NavLink>
                            {isAdmin && (
                                <NavLink to="/socias" className={navLinkClass}>
                                    <i className="fa fa-users"></i>
                                    <span>Socias</span>
                                </NavLink>
                            )}
                        </div>

                        {/* Zona derecha */}
                        <div className="navbar-right">
                            <span className="navbar-username">Hola, {displayName}</span>

                            <button
                                className={`menu-toggle-btn ${isOpen ? 'active' : ''}`}
                                onClick={toggleMenu}
                                aria-label="Abrir menú"
                                aria-expanded={isOpen}
                            >
                                <i className={`fa ${isOpen ? 'fa-times' : 'fa-bars'}`}></i>
                            </button>

                            {isOpen && (
                                <div className="dropdown-menu">
                                    {/* Links visibles solo en móvil dentro del menú */}
                                    <div className="mobile-nav-section">
                                        <button className="menu-item" onClick={() => handleNavigation('/dashboard')}>
                                            <i className="fa fa-home"></i>
                                            Liga
                                        </button>
                                        {isCaptain && (
                                            <button className="menu-item" onClick={() => handleNavigation('/estadisticas')}>
                                                <i className="fa fa-bar-chart"></i>
                                                Estadísticas
                                            </button>
                                        )}
                                        <button className="menu-item" onClick={() => handleNavigation('/americanas')}>
                                            <i className="fa fa-star"></i>
                                            Americanas
                                        </button>
                                        {isAdmin && (
                                            <button className="menu-item" onClick={() => handleNavigation('/socias')}>
                                                <i className="fa fa-users"></i>
                                                Socias
                                            </button>
                                        )}
                                        <div className="menu-divider"></div>
                                    </div>

                                    <button className="menu-item" onClick={() => handleNavigation('/account')}>
                                        <i className="fa fa-user-circle"></i>
                                        Mi Cuenta
                                    </button>

                                    {isAdmin && (
                                        <>
                                            <div className="menu-divider"></div>
                                            <button className="menu-item" onClick={() => handleNavigation('/register')}>
                                                <i className="fa fa-user-plus"></i>
                                                Registrar Jugadora
                                            </button>
                                        </>
                                    )}

                                    <div className="menu-divider"></div>

                                    <button
                                        className="menu-item"
                                        onClick={handleLogout}
                                        style={{ color: '#EF4444' }}
                                    >
                                        <i className="fa fa-sign-out" style={{ color: '#EF4444' }}></i>
                                        Cerrar Sesión
                                    </button>
                                </div>
                            )}
                        </div>
                    </>
                )}
            </nav>

            {isOpen && <div className="menu-backdrop" onClick={closeMenu}></div>}
        </>
    );
}

export default Navbar;
